<template>
  <div class="protectList">
    <breadcrumb class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName"
                :childPathThree="childPathThree" :childNameThree="childNameThree"></breadcrumb>
    <div class="main-row contain">
      <div class="col col-xlg-12 col-sm-12 protectList-item">
        <div class="searchStyle" >
           <div style="width: 60%;">
             <el-form :inline="true" label-position="top" :model="searchForm">
               <el-form-item label="科中文名" prop="sectionChinese">
                 <el-input v-model="searchForm.sectionChinese" placeholder="科中文名"/>
               </el-form-item>
               <el-form-item label="科拉丁名" prop="sectionLatin">
                 <el-input v-model="searchForm.sectionLatin" placeholder="科拉丁名"/>
               </el-form-item>
               <el-form-item label="学名" prop="scientificName">
                 <el-input v-model="searchForm.scientificName" placeholder="学名"/>
               </el-form-item>
               <el-form-item label="分布" prop="distribution">
                 <el-input v-model="searchForm.distribution" placeholder="分布"/>
               </el-form-item>
               <div style="display: inline-block" class="button">
                 <el-button type="primary" @click="onSubmit">查询</el-button>
                 <el-button type="primary" @click="backSubmit">返回</el-button>
               </div>
             </el-form>
           </div>
          <div style="background-color:#fff;width: 40%;font-size: 13px;padding-left: 8px;text-align: left">
            <p style="padding: 10px 0"><span style="font-weight: 700">国家重点保护：</span>国家林业和草原局 农村和农业部 2021年第15号公告 《国家重点保护野生植物名录》, http://www.forestry.gov.cn/main/5461/20210908/162515850572900.html</p>
            <p style="padding-bottom: 10px"><span style="font-weight: 700">中国红色名录：</span>生态环境部 中国科学院 2023年 第15号公告 《中国生物多样性红色名录—高等植物卷（2020）》, https://www.mee.gov.cn/xxgk2018/xxgk/xxgk01/202305/t20230522_1030745.html</p>
            <p style="padding-bottom: 10px">杨永 (2021) 中国裸子植物红色名录评估(2021版). 生物多样性, 29, 1599-1606. DOI: 10.17520/biods.2021342.</p>
            <p style="padding-bottom: 10px"><span style="font-weight: 700">云南极小种群：</span>云南省极小种群野生植物保护名录：2021版. 孙卫邦主编. --昆明：云南科技出版社, 2021.12</p>
          </div>
        </div>
        <template >
          <el-table border style="width: 100%" :row-style="{height: '8px'}"
                    :cell-style="{padding:'0px'}" :header-cell-style="{backgroundColor: '#eee',color: '#333'}" :data="tableData">
            <el-table-column type="index" header-align="center" align="left" label="序号" width="80">
              <template slot-scope="scope">
                <span>{{ (pageIndex - 1) * pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sectionChinese" header-align="center" align="left" label="科中文名" show-overflow-tooltip/>
            <el-table-column prop="sectionLatin" header-align="center" align="left" label="科拉丁名"  show-overflow-tooltip/>
            <el-table-column prop="chineseName" header-align="center" align="left" label="中文名"  show-overflow-tooltip/>
            <el-table-column prop="scientificName" header-align="center" align="left" label="学名" show-overflow-tooltip/>
            <el-table-column prop="countryProtect" header-align="center" align="left" label="国家重点保护"  show-overflow-tooltip/>
            <el-table-column prop="redDirectory" header-align="center" align="left" label="中国红色名录"  show-overflow-tooltip/>
            <el-table-column prop="minimumPopulation" header-align="center" align="left" label="云南极小种群" show-overflow-tooltip/>
            <el-table-column prop="distribution" header-align="center" align="left" label="本项目区域中的分布"  show-overflow-tooltip/>
            <el-table-column prop="note" header-align="center" align="left" label="备注"  show-overflow-tooltip/>
            <el-table-column header-align="center" align="left" label="操作" fixed="right" >
              <template slot-scope="scope">
                <el-button  type="text" @click="toTableDetail(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagin" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" :page-sizes="[25,50,75,100]" layout="total,sizes, prev, pager, next" :total="total"></el-pagination>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 高黎贡山-伯舒拉岭受威胁植物名录
 */
import breadcrumb from '@/components/breadcrumb'
import { fetchList } from '../../../network/gaoligongdirectory/wildPlant'

export default {
  name: "protectList",
  components: { breadcrumb },
  data() {
    return {
      path: '',
      name: '',
      childName:'',
      childPath:'',
      childPathThree: '',
      childNameThree: '',
      tableData: [],
      type: 'riskPlantDirectory',
      pageIndex: 1,
      pageSize: 25,
      searchForm: {},
      total: 0,
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      vm.name = '资源'
    })
  },
  mounted() {
    this.getList()
    this.$nextTick(() => {
    })
  },

  created() {

    this.childPathThree=this.$route.path
    this.childNameThree = this.$route.name
    this.childName = '名录'
    this.childPath = this.$route.path
  },
  methods: {
    getList() {
      fetchList(Object.assign({
        page: this.pageIndex,
        pageSize: this.pageSize,
        // type: this.type
      }, this.searchForm)).then(res => {
        // console.log('124545',res)
        this.tableData = res.data.data.riskPlantDirectoryList
        this.total = res.data.data.total
      })
    },
    handleSizeChange(val){
      this.pageSize = val
      this.page = 1
      this.getList()

    },
    handleCurrentChange(val){
      this.page = val
      this.getList()
    },
    toTableDetail(row) {
      this.$router.push({
        path: '/tableDetail',
        query: {
          id: row.id,
          formName: this.type,
          name: '高黎贡山-伯舒拉岭受威胁植物名录'
        }
      })
    },
    onSubmit() {
      this.page = 1
      this.getList()
    },
    backSubmit() {
      this.page = 1
      this.searchForm = {}
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/protectList";
::v-deep .el-pagination {
  padding: 20px 5px !important;
  text-align: center;
}
</style>
